export enum MasterMaterialHierarchyLevels{
  _0 ='Performance Center',
  _1 ='Product Center',
  _2 ='Planned Product',
  _3 ='Trade Product',
  _4 ='Material'
}